var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/index.ts
import {
  memo,
  useRef,
  forwardRef,
  useEffect,
  useImperativeHandle,
  createElement
} from "react";
import { easepick } from "@easepick/core";
import { DateTime } from "@easepick/datetime";
function getTimeValue(date) {
  if (!date)
    return void 0;
  if (date instanceof Date)
    return date.getTime();
  return new DateTime(date).getTime();
}
function updateInputValue(value, picker) {
  var _a, _b, _c, _d, _e, _f, _g;
  const rangePlugin = picker.PluginManager.getInstance("RangePlugin");
  if (!value) {
    if (rangePlugin) {
      if (((_a = picker.getStartDate()) == null ? void 0 : _a.getTime()) || ((_b = picker.getEndDate()) == null ? void 0 : _b.getTime())) {
        picker.clear();
        return;
      }
    } else {
      if ((_c = picker.getDate()) == null ? void 0 : _c.getTime()) {
        picker.clear();
        return;
      }
    }
    return;
  }
  const { format, lang } = picker.options;
  if (rangePlugin) {
    const { delimiter } = rangePlugin.options;
    const [start, end] = value.split(rangePlugin.options.delimiter);
    const startDate = DateTime.parseDateTime(start, format, lang);
    const endDate = DateTime.parseDateTime(end, format, lang);
    const startString = new DateTime(startDate).format(format, lang);
    const endString = new DateTime(endDate).format(format, lang);
    if (`${startString}${delimiter}${endString}` === value) {
      if (startDate.getTime() !== ((_d = picker.getStartDate()) == null ? void 0 : _d.getTime()) || endDate.getTime() !== ((_e = picker.getEndDate()) == null ? void 0 : _e.getTime())) {
        if (rangePlugin.options.strict) {
          if (startDate && endDate) {
            picker.setDateRange(startDate, endDate);
          }
        } else {
          if (startDate)
            picker.setStartDate(startDate);
          if (endDate)
            picker.setEndDate(endDate);
        }
      }
    } else if (startString === value || `${startString}${delimiter}` === value) {
      if (rangePlugin.options.strict && startDate.getTime() !== ((_f = picker.getStartDate()) == null ? void 0 : _f.getTime())) {
        picker.setStartDate(startDate);
      }
    }
  } else {
    const date = DateTime.parseDateTime(value, format, lang);
    if (new DateTime(date).format(format, lang) === value) {
      if (date.getTime() !== ((_g = picker.getDate()) == null ? void 0 : _g.getTime())) {
        picker.setDate(date);
      }
    }
  }
}
var EasePickWrapper = forwardRef(function EasePicker(props, ref) {
  const inputRef = useRef(null);
  useImperativeHandle(ref, () => inputRef.current);
  const _a = props, { date, startDate, endDate, options } = _a, inputProps = __objRest(_a, ["date", "startDate", "endDate", "options"]);
  const { value } = props;
  const dataValue = getTimeValue(date);
  const dataStart = getTimeValue(startDate);
  const dataEnd = getTimeValue(endDate);
  useEffect(() => {
    const element = inputRef.current;
    if (!element) {
      return;
    }
    if (element.pickerInstance) {
      element.pickerInstance.destroy();
      element.value = "";
    }
    element.pickerInstance = new easepick.create(__spreadProps(__spreadValues({}, options), {
      date: dataValue,
      element,
      RangePlugin: __spreadProps(__spreadValues({}, options.RangePlugin), {
        startDate: dataStart ? new DateTime(dataStart) : void 0,
        endDate: dataEnd ? new DateTime(dataEnd) : void 0
      })
    }));
    if (value) {
      updateInputValue(value, element.pickerInstance);
    }
  }, [options]);
  useEffect(() => {
    var _a2;
    if (value !== void 0) {
      return;
    }
    const element = inputRef.current;
    if (!element || !element.pickerInstance) {
      return;
    }
    const picker = element.pickerInstance;
    const rangePlugin = picker.PluginManager.getInstance("RangePlugin");
    if (rangePlugin) {
      return;
    }
    if (dataValue !== ((_a2 = picker.getDate()) == null ? void 0 : _a2.getTime())) {
      if (dataValue) {
        picker.setDate(dataValue);
      } else {
        picker.clear();
      }
    }
  }, [dataValue]);
  useEffect(() => {
    var _a2, _b;
    if (value !== void 0) {
      return;
    }
    const element = inputRef.current;
    if (!element || !element.pickerInstance) {
      return;
    }
    const picker = element.pickerInstance;
    const rangePlugin = picker.PluginManager.getInstance("RangePlugin");
    if (!rangePlugin) {
      return;
    }
    if (dataStart !== ((_a2 = picker.getStartDate()) == null ? void 0 : _a2.getTime()) || dataEnd !== ((_b = picker.getEndDate()) == null ? void 0 : _b.getTime())) {
      if (!dataStart) {
        picker.clear();
        return;
      }
      if (rangePlugin.options.strict) {
        if (dataStart && dataEnd) {
          picker.setDateRange(dataStart, dataEnd);
        }
      } else {
        if (dataStart)
          picker.setStartDate(dataStart);
        if (dataEnd)
          picker.setEndDate(dataEnd);
      }
    }
  }, [dataStart, dataEnd]);
  useEffect(() => {
    if (value === void 0) {
      return;
    }
    const element = inputRef.current;
    if (!element || !element.pickerInstance) {
      return;
    }
    updateInputValue(value, element.pickerInstance);
  }, [value]);
  return createElement("input", __spreadValues(__spreadValues(__spreadValues(__spreadProps(__spreadValues({}, inputProps), {
    ref: inputRef,
    type: "text"
  }), dataValue !== void 0 ? { "data-value": dataValue } : {}), dataStart !== void 0 ? { "data-start": dataStart } : {}), dataEnd !== void 0 ? { "data-end": dataEnd } : {}));
});
var src_default = memo(EasePickWrapper);
export {
  src_default as default
};
